import { Box } from "@mui/material";
import { browserName } from "react-device-detect";
import MobileLanding from "./MobileLanding";
import PcLanding from "./PcLanding";

const Landing = ({ isMobile, handleInstallClick }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        backgroundColor: "#091057",
      }}
    >
      {isMobile ? (
        <MobileLanding browserName={browserName} />
      ) : (
        <PcLanding
          browserName={browserName}
          handleInstallClick={handleInstallClick}
        />
      )}
    </Box>
  );
};

export default Landing;
